import axios from 'axios';
import jwtDecode from 'jwt-decode';
import {
  AUTH_CHECK,
  AUTH_ERROR,
  AUTH_LOGIN,
  AUTH_LOGOUT,
  AUTH_GET_PERMISSIONS
} from 'react-admin';

import { getIcError } from './utils';

const API_URL = 'v1';

// Token refresh timer
const REFRESH_TIMEOUT = 2 * 60 * 1000; // 2 minutes;
let refreshTimeout = undefined;

const startTokenRefresh = () => {
  refreshTimeout = setInterval(() => {
    const token = sessionStorage.getItem('token');
    const tenant = sessionStorage.getItem('tenant');
    var request = {
      method: 'GET',
      url: API_URL + '/user/auth',
      headers: {
        'Content-Type': 'application/json',
        'IC-USER-CLIENT': Buffer.from(tenant).toString('base64'),
        'X-IC-ACCESS-TOKEN': token
      }
    };

    let error = undefined;
    return axios.request(request).then(response => {
      if (response.status !== 200) {
        error = response.statusText;
      }
      if (response.status === 404) {
        return 'Server not responding';
      }

      if (error !== undefined) {
        error = getIcError(response.data) || error;
        throw new Error(error);
      }
      sessionStorage.setItem('token', response.data.accessToken);
    });
  }, REFRESH_TIMEOUT);
};

const stopTokenRefresh = () => {
  if (refreshTimeout !== undefined) {
    clearInterval(refreshTimeout);
    refreshTimeout = undefined;
  }
};

const getPermissions = () => {
  const token = sessionStorage.getItem('token');
  const tenant = sessionStorage.getItem('tenant');

  // Get Authorities
  var authoritiesRequest = {
    method: 'GET',
    url: API_URL + '/authorities',
    headers: {
      'Content-Type': 'application/json',
      'IC-USER-CLIENT': Buffer.from(tenant).toString('base64'),
      'X-IC-ACCESS-TOKEN': token
    }
  };

  let error = undefined;
  return axios.request(authoritiesRequest).then(response => {
    if (response.status !== 200) {
      error = response.statusText;
    }
    if (response.status === 404) {
      return 'Server not responding';
    }

    if (error !== undefined) {
      error = getIcError(response.data) || error;
      throw new Error(error);
    }

    return response.data;
  });
};

export default (type, params) => {
  if (type === AUTH_LOGIN) {
    const { username, password, tenant } = params;
    sessionStorage.setItem('tenant', tenant);

    var request = {
      method: 'GET',
      url: API_URL + '/user/auth',
      headers: {
        'Content-Type': 'application/json',
        'IC-USER-CLIENT': Buffer.from(tenant).toString('base64'),
        'IC-USER-ID': Buffer.from(username).toString('base64'),
        'IC-USER-PASSWORD': Buffer.from(password).toString('base64')
      }
    };

    let error = undefined;
    return axios
      .request(request)
      .then(response => {
        if (response.status !== 200) {
          error = response.statusText;
        }

        if (error !== undefined) {
          error = getIcError(response.data) || error;
          throw new Error(error);
        }

        sessionStorage.setItem('token', response.data.accessToken);
        startTokenRefresh();
      })
      .catch(error => {
        if (error.response) {
          switch (error.response.status) {
            case 401:
              error.message = 'ra.auth.sign_in_error';
              break;
            case 504:
              error.message = 'ra.network._504';
              break;
            default:
            //error.message = 'ra.network.http_error';
          }
        }
        throw error;
      });
  }

  if (type === AUTH_LOGOUT) {
    sessionStorage.removeItem('token');
    sessionStorage.removeItem('tenant');

    stopTokenRefresh();

    return Promise.resolve();
  }
  if (type === AUTH_ERROR) {
    const status = params.status;
    if (status === 401 || status === 403) {
      sessionStorage.removeItem('token');
      sessionStorage.removeItem('tenant');

      return Promise.reject();
    }
    return Promise.resolve();
  }
  if (type === AUTH_CHECK) {
    // Check that token is there
    const token = sessionStorage.getItem('token');
    if (!token) {
      return Promise.reject();
    }
    // Test for token expiration
    const jwt = jwtDecode(token);
    var current_time = Date.now();
    if (!isNaN(jwt.exp) && jwt.exp * 1000 < current_time) {
      return Promise.reject();
    }
    // Everything OK
    return Promise.resolve();
  }
  if (type === AUTH_GET_PERMISSIONS) {
    const token = sessionStorage.getItem('token');
    if (!token) {
      return Promise.reject();
    }
    return getPermissions();
  }
  return Promise.reject('Unknown auth method ' + type);
};
